module.exports = __webpack_public_path__ + "static/team4-06788c3f396016c8eea609ecbed4b1a1.png";